'use client';

import { c as _c } from "react/compiler-runtime";
import { Sparkles, Wifi, BrainCircuit } from 'lucide-react';
const messages = [{
  sender: 'penny',
  text: "Hi Sarah, I can see you're in a difficult situation. Can you tell me a bit about your current monthly income?"
}, {
  sender: 'customer',
  text: "I earn about £2,800 a month after tax, but I've had some unexpected bills recently"
}, {
  sender: 'penny',
  text: 'I understand. Let me connect to your bank account to get a clearer picture of your finances...'
}, {
  sender: 'indicator',
  text: 'Open Banking connected'
}, {
  sender: 'penny',
  text: "I've analysed your last 3 months. Here's what I found:"
}];
const keyframesCSS = `
@keyframes chat-fade-in {
  from { opacity: 0; transform: translateY(12px); }
  to { opacity: 1; transform: translateY(0); }
}
`;
export default function PennyChatPreview() {
  const $ = _c(12);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      width: "100%",
      maxWidth: 420
    };
    t1 = <style dangerouslySetInnerHTML={{
      __html: keyframesCSS
    }} />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex items-center justify-center rounded-full" style={{
      width: 36,
      height: 36,
      background: "linear-gradient(135deg, #00d4aa, #8b5cf6)"
    }}><Sparkles className="h-4 w-4 text-white" /></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="flex-1"><p className="text-sm font-semibold text-white">Penny</p><p className="text-xs text-white/50">AI Assistant</p></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex items-center gap-3 px-5 py-4 border-b border-white/10">{t2}{t3}<div className="flex items-center gap-1.5"><div className="w-2 h-2 rounded-full bg-green-400" style={{
          boxShadow: "0 0 6px rgba(74,222,128,0.6)"
        }} /><span className="text-xs text-green-400 font-medium">Live</span></div></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      maxHeight: 340,
      overflowY: "auto"
    };
    t6 = messages.map(_temp);
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      animation: `chat-fade-in 0.5s ease-out ${messages.length * 0.6}s both`
    };
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <div className="flex items-center gap-2 mb-2"><BrainCircuit className="h-4 w-4 text-cyan-400" /><span className="text-xs font-semibold text-cyan-400 uppercase tracking-wider">AI Insight</span></div>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <span className="text-white font-semibold">£2,800</span>;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <span className="text-white font-semibold">£1,650</span>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <div className="glass-strong rounded-3xl overflow-hidden" style={t0}>{t1}{t4}<div className="px-4 py-4 space-y-3" style={t5}>{t6}<div className="glass rounded-2xl p-4 border border-cyan-500/20" style={t7}>{t8}<p className="text-sm text-white/80">Monthly Income: {t9} · Essential spend: {t10} · Disposable: <span className="text-white font-semibold">£1,150</span></p></div></div></div>;
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  return t11;
}
function _temp(msg, i) {
  const delay = `${i * 0.6}s`;
  if (msg.sender === "indicator") {
    return <div key={i} className="flex items-center justify-center gap-2 py-2" style={{
      animation: `chat-fade-in 0.5s ease-out ${delay} both`
    }}><Wifi className="h-3.5 w-3.5 text-teal-400" /><span className="text-xs text-teal-400 font-medium">{msg.text}</span></div>;
  }
  const isPenny = msg.sender === "penny";
  return <div key={i} className={`flex ${isPenny ? "justify-start" : "justify-end"}`} style={{
    animation: `chat-fade-in 0.5s ease-out ${delay} both`
  }}><div className={`rounded-2xl px-4 py-2.5 text-sm leading-relaxed ${isPenny ? "glass rounded-bl-md text-white/90" : "rounded-br-md text-white"}`} style={{
      maxWidth: "85%",
      ...(isPenny ? {} : {
        background: "linear-gradient(135deg, #00d4aa, #0d9488)"
      })
    }}>{msg.text}</div></div>;
}